function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-9{fill:#dee5fc;}.cls-2,.cls-9{opacity:0.8;}.cls-3{isolation:isolate;}.cls-4{clip-path:url(#clip-path);}.cls-5{clip-path:url(#clip-path-2);}.cls-6{fill:#ccd8ff;opacity:0.74;}.cls-7{clip-path:url(#clip-path-3);}.cls-8{fill:#ebefff;}.cls-10{clip-path:url(#clip-path-4);}.cls-11{clip-path:url(#clip-path-5);}.cls-12{clip-path:url(#clip-path-6);}.cls-13{clip-path:url(#clip-path-7);}.cls-14{clip-path:url(#clip-path-8);}.cls-15{clip-path:url(#clip-path-9);}.cls-16{clip-path:url(#clip-path-10);}.cls-17{clip-path:url(#clip-path-11);}.cls-18{clip-path:url(#clip-path-12);}.cls-19{clip-path:url(#clip-path-13);}.cls-20{clip-path:url(#clip-path-14);}.cls-21{clip-path:url(#clip-path-15);}.cls-22{clip-path:url(#clip-path-16);}.cls-23{clip-path:url(#clip-path-17);}.cls-24{clip-path:url(#clip-path-18);}.cls-25{clip-path:url(#clip-path-19);}.cls-26{clip-path:url(#clip-path-20);}.cls-27{clip-path:url(#clip-path-21);}.cls-28{clip-path:url(#clip-path-22);}.cls-29{clip-path:url(#clip-path-23);}.cls-30{clip-path:url(#clip-path-24);}.cls-31{clip-path:url(#clip-path-25);}.cls-32{clip-path:url(#clip-path-26);}.cls-33{clip-path:url(#clip-path-27);}.cls-34{clip-path:url(#clip-path-28);}.cls-35{clip-path:url(#clip-path-29);}.cls-36{clip-path:url(#clip-path-30);}.cls-37{clip-path:url(#clip-path-31);}.cls-38{clip-path:url(#clip-path-32);}.cls-39{clip-path:url(#clip-path-33);}.cls-40{clip-path:url(#clip-path-34);}.cls-41{clip-path:url(#clip-path-35);}.cls-42{clip-path:url(#clip-path-36);}.cls-43{clip-path:url(#clip-path-37);}.cls-44{clip-path:url(#clip-path-38);}.cls-45{clip-path:url(#clip-path-39);}.cls-46{clip-path:url(#clip-path-40);}.cls-47{clip-path:url(#clip-path-41);}.cls-48{clip-path:url(#clip-path-42);}.cls-49{clip-path:url(#clip-path-43);}.cls-50{clip-path:url(#clip-path-44);}.cls-51{clip-path:url(#clip-path-45);}.cls-52{clip-path:url(#clip-path-46);}.cls-53{clip-path:url(#clip-path-47);}.cls-54{clip-path:url(#clip-path-48);}.cls-55{clip-path:url(#clip-path-49);}.cls-56{clip-path:url(#clip-path-50);}.cls-57{clip-path:url(#clip-path-51);}.cls-58{clip-path:url(#clip-path-52);}.cls-59{clip-path:url(#clip-path-53);}.cls-60{clip-path:url(#clip-path-54);}.cls-61{clip-path:url(#clip-path-55);}.cls-62{clip-path:url(#clip-path-56);}.cls-63{clip-path:url(#clip-path-57);}.cls-64{clip-path:url(#clip-path-58);}.cls-65{clip-path:url(#clip-path-59);}.cls-66{clip-path:url(#clip-path-60);}.cls-67{clip-path:url(#clip-path-61);}.cls-68{clip-path:url(#clip-path-62);}.cls-69{clip-path:url(#clip-path-63);}.cls-70{clip-path:url(#clip-path-64);}.cls-71{clip-path:url(#clip-path-65);}.cls-72{clip-path:url(#clip-path-66);}.cls-73{clip-path:url(#clip-path-69);}.cls-74{clip-path:url(#clip-path-70);}.cls-75{clip-path:url(#clip-path-71);}.cls-76{clip-path:url(#clip-path-72);}.cls-77{clip-path:url(#clip-path-73);}.cls-78{clip-path:url(#clip-path-74);}.cls-79{clip-path:url(#clip-path-75);}.cls-80{clip-path:url(#clip-path-76);}.cls-81{clip-path:url(#clip-path-77);}.cls-82{clip-path:url(#clip-path-78);}.cls-83{clip-path:url(#clip-path-79);}.cls-84{clip-path:url(#clip-path-80);}.cls-85{clip-path:url(#clip-path-81);}.cls-86{clip-path:url(#clip-path-82);}.cls-87{fill:#4b5fef;}.cls-88{clip-path:url(#clip-path-83);}.cls-89{fill:#5a67ff;}.cls-90{fill:#7687ff;}"), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 54.32 77.66 65.53 77.66 87.95 58.25 76.74 58.25 54.32"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-2"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 65.53 77.66 87.95 58.25 99.16 58.25 76.74 77.66 65.53"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 76.74 58.25 99.16 38.83 87.95 38.83 65.53 58.25 76.74"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-4"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 65.53 97.08 76.74 97.08 99.16 77.66 87.95 77.66 65.53"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-5"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "97.08 76.74 97.08 99.16 77.66 110.37 77.66 87.95 97.08 76.74"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-6"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 87.95 77.66 110.37 58.25 99.16 58.25 76.74 77.66 87.95"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-7"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 76.74 77.66 87.95 77.66 110.37 58.25 99.16 58.25 76.74"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-8"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 87.95 77.66 110.37 58.25 121.58 58.25 99.16 77.66 87.95"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-9"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 99.16 58.25 121.58 38.83 110.37 38.83 87.95 58.25 99.16"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-10"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "38.83 65.53 58.25 76.74 58.25 99.16 38.83 87.95 38.83 65.53"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-11"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 76.74 58.25 99.16 38.83 110.37 38.83 87.95 58.25 76.74"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-12"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "38.83 87.95 38.83 110.37 19.42 99.16 19.42 76.74 38.83 87.95"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-13"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "19.42 76.74 38.83 87.95 38.83 110.37 19.42 99.16 19.42 76.74"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-14"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "38.83 87.95 38.83 110.37 19.42 121.58 19.42 99.16 38.83 87.95"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-15"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "19.42 99.16 19.42 121.58 0 110.37 0 87.95 19.42 99.16"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-16"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "38.83 87.95 58.25 99.16 58.25 121.58 38.83 110.37 38.83 87.95"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-17"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 99.16 58.25 121.58 38.83 132.79 38.83 110.37 58.25 99.16"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-18"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "38.83 110.37 38.83 132.79 19.42 121.58 19.42 99.16 38.83 110.37"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-19"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "97.08 76.74 116.5 87.95 116.5 110.37 97.08 99.16 97.08 76.74"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-20"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "116.5 87.95 116.5 110.37 97.08 121.58 97.08 99.16 116.5 87.95"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-21"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "97.08 99.16 97.08 121.58 77.66 110.37 77.66 87.95 97.08 99.16"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-22"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 87.95 97.08 99.16 97.08 121.58 77.66 110.37 77.66 87.95"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-23"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "97.08 99.16 97.08 121.58 77.66 132.79 77.66 110.37 97.08 99.16"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-24"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 110.37 77.66 132.79 58.25 121.58 58.25 99.16 77.66 110.37"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-25"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 99.16 77.66 110.37 77.66 132.79 58.25 121.58 58.25 99.16"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-26"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 110.37 77.66 132.79 58.25 144 58.25 121.58 77.66 110.37"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-27"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 121.58 58.25 144 38.83 132.79 38.83 110.37 58.25 121.58"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-28"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 31.9 77.66 43.11 77.66 65.53 58.25 54.32 58.25 31.9"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-29"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 43.11 77.66 65.53 58.25 76.74 58.25 54.32 77.66 43.11"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-30"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 54.32 58.25 76.74 38.83 65.53 38.83 43.11 58.25 54.32"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-31"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 43.11 97.08 54.32 97.08 76.74 77.66 65.53 77.66 43.11"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-32"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "97.08 54.32 97.08 76.74 77.66 87.95 77.66 65.53 97.08 54.32"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-33"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 65.53 77.66 87.95 58.25 76.74 58.25 54.32 77.66 65.53"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-34"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "97.08 54.32 116.5 65.53 116.5 87.95 97.08 76.74 97.08 54.32"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-35"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "116.5 65.53 116.5 87.95 97.08 99.16 97.08 76.74 116.5 65.53"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-36"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "97.08 76.74 97.08 99.16 77.66 87.95 77.66 65.53 97.08 76.74"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-37"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 54.32 77.66 65.53 77.66 87.95 58.25 76.74 58.25 54.32"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-38"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 65.53 77.66 87.95 58.25 99.16 58.25 76.74 77.66 65.53"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-39"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 76.74 58.25 99.16 38.83 87.95 38.83 65.53 58.25 76.74"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-40"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "38.83 43.11 58.25 54.32 58.25 76.74 38.83 65.53 38.83 43.11"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-41"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 54.32 58.25 76.74 38.83 87.95 38.83 65.53 58.25 54.32"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-42"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "38.83 65.53 38.83 87.95 19.42 76.74 19.42 54.32 38.83 65.53"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-43"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 65.53 97.08 76.74 97.08 99.16 77.66 87.95 77.66 65.53"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-44"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "97.08 76.74 97.08 99.16 77.66 110.37 77.66 87.95 97.08 76.74"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-45"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 87.95 77.66 110.37 58.25 99.16 58.25 76.74 77.66 87.95"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-46"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "19.42 54.32 38.83 65.53 38.83 87.95 19.42 76.74 19.42 54.32"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-47"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "38.83 65.53 38.83 87.95 19.42 99.16 19.42 76.74 38.83 65.53"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-48"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "19.42 76.74 19.42 99.16 0 87.95 0 65.53 19.42 76.74"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-49"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "38.83 65.53 58.25 76.74 58.25 99.16 38.83 87.95 38.83 65.53"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-50"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 76.74 58.25 99.16 38.83 110.37 38.83 87.95 58.25 76.74"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-51"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "38.83 87.95 38.83 110.37 19.42 99.16 19.42 76.74 38.83 87.95"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-52"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 76.74 77.66 87.95 77.66 110.37 58.25 99.16 58.25 76.74"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-53"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 87.95 77.66 110.37 58.25 121.58 58.25 99.16 77.66 87.95"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-54"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 99.16 58.25 121.58 38.83 110.37 38.83 87.95 58.25 99.16"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-55"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 9.48 77.66 20.69 77.66 43.11 58.25 31.9 58.25 9.48"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-56"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 20.69 77.66 43.11 58.25 54.32 58.25 31.9 77.66 20.69"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-57"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 31.9 58.25 54.32 38.83 43.11 38.83 20.69 58.25 31.9"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-58"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 31.9 77.66 43.11 77.66 65.53 58.25 54.32 58.25 31.9"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-59"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 43.11 77.66 65.53 58.25 76.74 58.25 54.32 77.66 43.11"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-60"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 54.32 58.25 76.74 38.83 65.53 38.83 43.11 58.25 54.32"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-61"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 20.69 97.08 31.9 97.08 54.32 77.66 43.11 77.66 20.69"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-62"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "97.08 31.9 97.08 54.32 77.66 65.53 77.66 43.11 97.08 31.9"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-63"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 43.11 77.66 65.53 58.25 54.32 58.25 31.9 77.66 43.11"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-64"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "38.83 20.69 58.25 31.9 58.25 54.32 38.83 43.11 38.83 20.69"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-65"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 31.9 58.25 54.32 38.83 65.53 38.83 43.11 58.25 31.9"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-66"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "38.83 43.11 38.83 65.53 19.42 54.32 19.42 31.9 38.83 43.11"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-69"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "19.42 31.9 38.83 43.11 38.83 65.53 19.42 54.32 19.42 31.9"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-70"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "38.83 43.11 38.83 65.53 19.42 76.74 19.42 54.32 38.83 43.11"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-71"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "19.42 54.32 19.42 76.74 0 65.53 0 43.11 19.42 54.32"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-72"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "38.83 43.11 58.25 54.32 58.25 76.74 38.83 65.53 38.83 43.11"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-73"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 54.32 58.25 76.74 38.83 87.95 38.83 65.53 58.25 54.32"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-74"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "38.83 65.53 38.83 87.95 19.42 76.74 19.42 54.32 38.83 65.53"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-75"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "97.08 31.9 116.5 43.11 116.5 65.53 97.08 54.32 97.08 31.9"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-76"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "116.5 43.11 116.5 65.53 97.08 76.74 97.08 54.32 116.5 43.11"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-77"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "97.08 54.32 97.08 76.74 77.66 65.53 77.66 43.11 97.08 54.32"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-78"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 43.11 97.08 54.32 97.08 76.74 77.66 65.53 77.66 43.11"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-79"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "97.08 54.32 97.08 76.74 77.66 87.95 77.66 65.53 97.08 54.32"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-80"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 65.53 77.66 87.95 58.25 76.74 58.25 54.32 77.66 65.53"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-81"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 0 77.66 11.21 77.66 33.63 58.25 22.42 58.25 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-82"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 11.21 77.66 33.63 58.25 44.84 58.25 22.42 77.66 11.21"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-83"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 22.42 58.25 44.84 38.83 33.63 38.83 11.21 58.25 22.42"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 54.32 77.66 65.53 77.66 87.95 58.25 76.74 58.25 54.32"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 54.32 77.66 65.53 77.66 87.95 58.25 76.74 58.25 54.32"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 65.53 77.66 87.95 58.25 99.16 58.25 76.74 77.66 65.53"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "77.66 65.53 77.66 87.95 58.25 99.16 58.25 76.74 77.66 65.53"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 76.74 58.25 99.16 38.83 87.95 38.83 65.53 58.25 76.74"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-7"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "58.25 76.74 58.25 99.16 38.83 87.95 38.83 65.53 58.25 76.74"
})))));

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "38.83 65.53 58.25 54.32 77.66 65.53 58.25 76.74 38.83 65.53"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 65.53 97.08 76.74 97.08 99.16 77.66 87.95 77.66 65.53"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-10"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 65.53 97.08 76.74 97.08 99.16 77.66 87.95 77.66 65.53"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "97.08 76.74 97.08 99.16 77.66 110.37 77.66 87.95 97.08 76.74"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-11"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "97.08 76.74 97.08 99.16 77.66 110.37 77.66 87.95 97.08 76.74"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 87.95 77.66 110.37 58.25 99.16 58.25 76.74 77.66 87.95"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-12"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "77.66 87.95 77.66 110.37 58.25 99.16 58.25 76.74 77.66 87.95"
})))));

var _ref6 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "58.25 76.74 77.66 65.53 97.08 76.74 77.66 87.95 58.25 76.74"
});

var _ref7 = /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 76.74 77.66 87.95 77.66 110.37 58.25 99.16 58.25 76.74"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-13"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 76.74 77.66 87.95 77.66 110.37 58.25 99.16 58.25 76.74"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 87.95 77.66 110.37 58.25 121.58 58.25 99.16 77.66 87.95"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-14"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "77.66 87.95 77.66 110.37 58.25 121.58 58.25 99.16 77.66 87.95"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 99.16 58.25 121.58 38.83 110.37 38.83 87.95 58.25 99.16"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-15"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "58.25 99.16 58.25 121.58 38.83 110.37 38.83 87.95 58.25 99.16"
})))));

var _ref8 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "38.83 87.95 58.25 76.74 77.66 87.95 58.25 99.16 38.83 87.95"
});

var _ref9 = /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "38.83 65.53 58.25 76.74 58.25 99.16 38.83 87.95 38.83 65.53"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-16"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "38.83 65.53 58.25 76.74 58.25 99.16 38.83 87.95 38.83 65.53"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 76.74 58.25 99.16 38.83 110.37 38.83 87.95 58.25 76.74"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-17"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "58.25 76.74 58.25 99.16 38.83 110.37 38.83 87.95 58.25 76.74"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "38.83 87.95 38.83 110.37 19.42 99.16 19.42 76.74 38.83 87.95"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-18"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "38.83 87.95 38.83 110.37 19.42 99.16 19.42 76.74 38.83 87.95"
})))));

var _ref10 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "19.42 76.74 38.83 65.53 58.25 76.74 38.83 87.95 19.42 76.74"
});

var _ref11 = /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "19.42 76.74 38.83 87.95 38.83 110.37 19.42 99.16 19.42 76.74"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-19"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "19.42 76.74 38.83 87.95 38.83 110.37 19.42 99.16 19.42 76.74"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "38.83 87.95 38.83 110.37 19.42 121.58 19.42 99.16 38.83 87.95"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-20"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "38.83 87.95 38.83 110.37 19.42 121.58 19.42 99.16 38.83 87.95"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "19.42 99.16 19.42 121.58 0 110.37 0 87.95 19.42 99.16"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-21"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "19.42 99.16 19.42 121.58 0 110.37 0 87.95 19.42 99.16"
})))));

var _ref12 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "0 87.95 19.42 76.74 38.83 87.95 19.42 99.16 0 87.95"
});

var _ref13 = /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "38.83 87.95 58.25 99.16 58.25 121.58 38.83 110.37 38.83 87.95"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-22"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "38.83 87.95 58.25 99.16 58.25 121.58 38.83 110.37 38.83 87.95"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 99.16 58.25 121.58 38.83 132.79 38.83 110.37 58.25 99.16"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-23"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "58.25 99.16 58.25 121.58 38.83 132.79 38.83 110.37 58.25 99.16"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "38.83 110.37 38.83 132.79 19.42 121.58 19.42 99.16 38.83 110.37"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-24"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "38.83 110.37 38.83 132.79 19.42 121.58 19.42 99.16 38.83 110.37"
})))));

var _ref14 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "19.42 99.16 38.83 87.95 58.25 99.16 38.83 110.37 19.42 99.16"
});

var _ref15 = /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "97.08 76.74 116.5 87.95 116.5 110.37 97.08 99.16 97.08 76.74"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-25"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "97.08 76.74 116.5 87.95 116.5 110.37 97.08 99.16 97.08 76.74"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "116.5 87.95 116.5 110.37 97.08 121.58 97.08 99.16 116.5 87.95"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-26"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "116.5 87.95 116.5 110.37 97.08 121.58 97.08 99.16 116.5 87.95"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "97.08 99.16 97.08 121.58 77.66 110.37 77.66 87.95 97.08 99.16"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-27"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "97.08 99.16 97.08 121.58 77.66 110.37 77.66 87.95 97.08 99.16"
})))));

var _ref16 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "77.66 87.95 97.08 76.74 116.5 87.95 97.08 99.16 77.66 87.95"
});

var _ref17 = /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 87.95 97.08 99.16 97.08 121.58 77.66 110.37 77.66 87.95"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-28"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 87.95 97.08 99.16 97.08 121.58 77.66 110.37 77.66 87.95"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "97.08 99.16 97.08 121.58 77.66 132.79 77.66 110.37 97.08 99.16"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-29"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "97.08 99.16 97.08 121.58 77.66 132.79 77.66 110.37 97.08 99.16"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 110.37 77.66 132.79 58.25 121.58 58.25 99.16 77.66 110.37"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-30"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "77.66 110.37 77.66 132.79 58.25 121.58 58.25 99.16 77.66 110.37"
})))));

var _ref18 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "58.25 99.16 77.66 87.95 97.08 99.16 77.66 110.37 58.25 99.16"
});

var _ref19 = /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 99.16 77.66 110.37 77.66 132.79 58.25 121.58 58.25 99.16"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-31"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 99.16 77.66 110.37 77.66 132.79 58.25 121.58 58.25 99.16"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 110.37 77.66 132.79 58.25 144 58.25 121.58 77.66 110.37"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-32"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "77.66 110.37 77.66 132.79 58.25 144 58.25 121.58 77.66 110.37"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 121.58 58.25 144 38.83 132.79 38.83 110.37 58.25 121.58"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-33"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "58.25 121.58 58.25 144 38.83 132.79 38.83 110.37 58.25 121.58"
})))));

var _ref20 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "38.83 110.37 58.25 99.16 77.66 110.37 58.25 121.58 38.83 110.37"
});

var _ref21 = /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 31.9 77.66 43.11 77.66 65.53 58.25 54.32 58.25 31.9"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-34"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 31.9 77.66 43.11 77.66 65.53 58.25 54.32 58.25 31.9"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 43.11 77.66 65.53 58.25 76.74 58.25 54.32 77.66 43.11"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-35"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "77.66 43.11 77.66 65.53 58.25 76.74 58.25 54.32 77.66 43.11"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 54.32 58.25 76.74 38.83 65.53 38.83 43.11 58.25 54.32"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-36"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "58.25 54.32 58.25 76.74 38.83 65.53 38.83 43.11 58.25 54.32"
})))));

var _ref22 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "38.83 43.11 58.25 31.9 77.66 43.11 58.25 54.32 38.83 43.11"
});

var _ref23 = /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 43.11 97.08 54.32 97.08 76.74 77.66 65.53 77.66 43.11"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-37"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 43.11 97.08 54.32 97.08 76.74 77.66 65.53 77.66 43.11"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "97.08 54.32 97.08 76.74 77.66 87.95 77.66 65.53 97.08 54.32"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-38"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "97.08 54.32 97.08 76.74 77.66 87.95 77.66 65.53 97.08 54.32"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 65.53 77.66 87.95 58.25 76.74 58.25 54.32 77.66 65.53"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-39"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "77.66 65.53 77.66 87.95 58.25 76.74 58.25 54.32 77.66 65.53"
})))));

var _ref24 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "58.25 54.32 77.66 43.11 97.08 54.32 77.66 65.53 58.25 54.32"
});

var _ref25 = /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "97.08 54.32 116.5 65.53 116.5 87.95 97.08 76.74 97.08 54.32"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-40"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "97.08 54.32 116.5 65.53 116.5 87.95 97.08 76.74 97.08 54.32"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "116.5 65.53 116.5 87.95 97.08 99.16 97.08 76.74 116.5 65.53"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-41"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "116.5 65.53 116.5 87.95 97.08 99.16 97.08 76.74 116.5 65.53"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "97.08 76.74 97.08 99.16 77.66 87.95 77.66 65.53 97.08 76.74"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-42"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "97.08 76.74 97.08 99.16 77.66 87.95 77.66 65.53 97.08 76.74"
})))));

var _ref26 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "77.66 65.53 97.08 54.32 116.5 65.53 97.08 76.74 77.66 65.53"
});

var _ref27 = /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 54.32 77.66 65.53 77.66 87.95 58.25 76.74 58.25 54.32"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-43"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 54.32 77.66 65.53 77.66 87.95 58.25 76.74 58.25 54.32"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 65.53 77.66 87.95 58.25 99.16 58.25 76.74 77.66 65.53"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-44"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "77.66 65.53 77.66 87.95 58.25 99.16 58.25 76.74 77.66 65.53"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 76.74 58.25 99.16 38.83 87.95 38.83 65.53 58.25 76.74"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-45"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "58.25 76.74 58.25 99.16 38.83 87.95 38.83 65.53 58.25 76.74"
})))));

var _ref28 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "38.83 65.53 58.25 54.32 77.66 65.53 58.25 76.74 38.83 65.53"
});

var _ref29 = /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "38.83 43.11 58.25 54.32 58.25 76.74 38.83 65.53 38.83 43.11"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-46"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "38.83 43.11 58.25 54.32 58.25 76.74 38.83 65.53 38.83 43.11"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 54.32 58.25 76.74 38.83 87.95 38.83 65.53 58.25 54.32"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-47"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "58.25 54.32 58.25 76.74 38.83 87.95 38.83 65.53 58.25 54.32"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "38.83 65.53 38.83 87.95 19.42 76.74 19.42 54.32 38.83 65.53"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-48"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "38.83 65.53 38.83 87.95 19.42 76.74 19.42 54.32 38.83 65.53"
})))));

var _ref30 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "19.42 54.32 38.83 43.11 58.25 54.32 38.83 65.53 19.42 54.32"
});

var _ref31 = /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 65.53 97.08 76.74 97.08 99.16 77.66 87.95 77.66 65.53"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-49"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 65.53 97.08 76.74 97.08 99.16 77.66 87.95 77.66 65.53"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "97.08 76.74 97.08 99.16 77.66 110.37 77.66 87.95 97.08 76.74"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-50"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "97.08 76.74 97.08 99.16 77.66 110.37 77.66 87.95 97.08 76.74"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 87.95 77.66 110.37 58.25 99.16 58.25 76.74 77.66 87.95"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-51"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "77.66 87.95 77.66 110.37 58.25 99.16 58.25 76.74 77.66 87.95"
})))));

var _ref32 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "58.25 76.74 77.66 65.53 97.08 76.74 77.66 87.95 58.25 76.74"
});

var _ref33 = /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "19.42 54.32 38.83 65.53 38.83 87.95 19.42 76.74 19.42 54.32"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-52"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "19.42 54.32 38.83 65.53 38.83 87.95 19.42 76.74 19.42 54.32"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "38.83 65.53 38.83 87.95 19.42 99.16 19.42 76.74 38.83 65.53"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-53"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "38.83 65.53 38.83 87.95 19.42 99.16 19.42 76.74 38.83 65.53"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "19.42 76.74 19.42 99.16 0 87.95 0 65.53 19.42 76.74"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-54"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "19.42 76.74 19.42 99.16 0 87.95 0 65.53 19.42 76.74"
})))));

var _ref34 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "0 65.53 19.42 54.32 38.83 65.53 19.42 76.74 0 65.53"
});

var _ref35 = /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "38.83 65.53 58.25 76.74 58.25 99.16 38.83 87.95 38.83 65.53"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-55"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "38.83 65.53 58.25 76.74 58.25 99.16 38.83 87.95 38.83 65.53"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 76.74 58.25 99.16 38.83 110.37 38.83 87.95 58.25 76.74"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-56"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "58.25 76.74 58.25 99.16 38.83 110.37 38.83 87.95 58.25 76.74"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "38.83 87.95 38.83 110.37 19.42 99.16 19.42 76.74 38.83 87.95"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-57"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "38.83 87.95 38.83 110.37 19.42 99.16 19.42 76.74 38.83 87.95"
})))));

var _ref36 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "19.42 76.74 38.83 65.53 58.25 76.74 38.83 87.95 19.42 76.74"
});

var _ref37 = /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 76.74 77.66 87.95 77.66 110.37 58.25 99.16 58.25 76.74"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-58"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 76.74 77.66 87.95 77.66 110.37 58.25 99.16 58.25 76.74"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 87.95 77.66 110.37 58.25 121.58 58.25 99.16 77.66 87.95"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-59"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "77.66 87.95 77.66 110.37 58.25 121.58 58.25 99.16 77.66 87.95"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 99.16 58.25 121.58 38.83 110.37 38.83 87.95 58.25 99.16"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-60"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "58.25 99.16 58.25 121.58 38.83 110.37 38.83 87.95 58.25 99.16"
})))));

var _ref38 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "38.83 87.95 58.25 76.74 77.66 87.95 58.25 99.16 38.83 87.95"
});

var _ref39 = /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 9.48 77.66 20.69 77.66 43.11 58.25 31.9 58.25 9.48"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-61"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 9.48 77.66 20.69 77.66 43.11 58.25 31.9 58.25 9.48"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 20.69 77.66 43.11 58.25 54.32 58.25 31.9 77.66 20.69"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-62"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "77.66 20.69 77.66 43.11 58.25 54.32 58.25 31.9 77.66 20.69"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 31.9 58.25 54.32 38.83 43.11 38.83 20.69 58.25 31.9"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-63"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "58.25 31.9 58.25 54.32 38.83 43.11 38.83 20.69 58.25 31.9"
})))));

var _ref40 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "38.83 20.69 58.25 9.48 77.66 20.69 58.25 31.9 38.83 20.69"
});

var _ref41 = /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 31.9 77.66 43.11 77.66 65.53 58.25 54.32 58.25 31.9"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-64"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 31.9 77.66 43.11 77.66 65.53 58.25 54.32 58.25 31.9"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 43.11 77.66 65.53 58.25 76.74 58.25 54.32 77.66 43.11"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-65"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "77.66 43.11 77.66 65.53 58.25 76.74 58.25 54.32 77.66 43.11"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 54.32 58.25 76.74 38.83 65.53 38.83 43.11 58.25 54.32"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-66"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "58.25 54.32 58.25 76.74 38.83 65.53 38.83 43.11 58.25 54.32"
})))));

var _ref42 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "38.83 43.11 58.25 31.9 77.66 43.11 58.25 54.32 38.83 43.11"
});

var _ref43 = /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 20.69 97.08 31.9 97.08 54.32 77.66 43.11 77.66 20.69"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-67"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 20.69 97.08 31.9 97.08 54.32 77.66 43.11 77.66 20.69"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "97.08 31.9 97.08 54.32 77.66 65.53 77.66 43.11 97.08 31.9"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-68"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "97.08 31.9 97.08 54.32 77.66 65.53 77.66 43.11 97.08 31.9"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 43.11 77.66 65.53 58.25 54.32 58.25 31.9 77.66 43.11"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-69"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "77.66 43.11 77.66 65.53 58.25 54.32 58.25 31.9 77.66 43.11"
})))));

var _ref44 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "58.25 31.9 77.66 20.69 97.08 31.9 77.66 43.11 58.25 31.9"
});

var _ref45 = /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "38.83 20.69 58.25 31.9 58.25 54.32 38.83 43.11 38.83 20.69"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-70"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "38.83 20.69 58.25 31.9 58.25 54.32 38.83 43.11 38.83 20.69"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 31.9 58.25 54.32 38.83 65.53 38.83 43.11 58.25 31.9"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-71"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "58.25 31.9 58.25 54.32 38.83 65.53 38.83 43.11 58.25 31.9"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "38.83 43.11 38.83 65.53 19.42 54.32 19.42 31.9 38.83 43.11"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-72"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "38.83 43.11 38.83 65.53 19.42 54.32 19.42 31.9 38.83 43.11"
})))));

var _ref46 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "19.42 31.9 38.83 20.69 58.25 31.9 38.83 43.11 19.42 31.9"
});

var _ref47 = /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 43.11 77.66 65.53 58.25 76.74 58.25 54.32 77.66 43.11"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-35"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "77.66 43.11 77.66 65.53 58.25 76.74 58.25 54.32 77.66 43.11"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 54.32 58.25 76.74 38.83 65.53 38.83 43.11 58.25 54.32"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-36"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "58.25 54.32 58.25 76.74 38.83 65.53 38.83 43.11 58.25 54.32"
}))), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "38.83 43.11 58.25 31.9 77.66 43.11 58.25 54.32 38.83 43.11"
})));

var _ref48 = /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "19.42 31.9 38.83 43.11 38.83 65.53 19.42 54.32 19.42 31.9"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-73"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "19.42 31.9 38.83 43.11 38.83 65.53 19.42 54.32 19.42 31.9"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "38.83 43.11 38.83 65.53 19.42 76.74 19.42 54.32 38.83 43.11"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-74"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "38.83 43.11 38.83 65.53 19.42 76.74 19.42 54.32 38.83 43.11"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "19.42 54.32 19.42 76.74 0 65.53 0 43.11 19.42 54.32"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-75"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "19.42 54.32 19.42 76.74 0 65.53 0 43.11 19.42 54.32"
})))));

var _ref49 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "0 43.11 19.42 31.9 38.83 43.11 19.42 54.32 0 43.11"
});

var _ref50 = /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "38.83 43.11 58.25 54.32 58.25 76.74 38.83 65.53 38.83 43.11"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-76"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "38.83 43.11 58.25 54.32 58.25 76.74 38.83 65.53 38.83 43.11"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 54.32 58.25 76.74 38.83 87.95 38.83 65.53 58.25 54.32"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-77"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "58.25 54.32 58.25 76.74 38.83 87.95 38.83 65.53 58.25 54.32"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "38.83 65.53 38.83 87.95 19.42 76.74 19.42 54.32 38.83 65.53"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-78"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "38.83 65.53 38.83 87.95 19.42 76.74 19.42 54.32 38.83 65.53"
})))));

var _ref51 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "19.42 54.32 38.83 43.11 58.25 54.32 38.83 65.53 19.42 54.32"
});

var _ref52 = /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "97.08 31.9 116.5 43.11 116.5 65.53 97.08 54.32 97.08 31.9"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-79"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "97.08 31.9 116.5 43.11 116.5 65.53 97.08 54.32 97.08 31.9"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "116.5 43.11 116.5 65.53 97.08 76.74 97.08 54.32 116.5 43.11"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-80"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "116.5 43.11 116.5 65.53 97.08 76.74 97.08 54.32 116.5 43.11"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "97.08 54.32 97.08 76.74 77.66 65.53 77.66 43.11 97.08 54.32"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-81"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "97.08 54.32 97.08 76.74 77.66 65.53 77.66 43.11 97.08 54.32"
})))));

var _ref53 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "77.66 43.11 97.08 31.9 116.5 43.11 97.08 54.32 77.66 43.11"
});

var _ref54 = /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 43.11 97.08 54.32 97.08 76.74 77.66 65.53 77.66 43.11"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-82"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 43.11 97.08 54.32 97.08 76.74 77.66 65.53 77.66 43.11"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "97.08 54.32 97.08 76.74 77.66 87.95 77.66 65.53 97.08 54.32"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-83"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "97.08 54.32 97.08 76.74 77.66 87.95 77.66 65.53 97.08 54.32"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 65.53 77.66 87.95 58.25 76.74 58.25 54.32 77.66 65.53"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-84"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "77.66 65.53 77.66 87.95 58.25 76.74 58.25 54.32 77.66 65.53"
})))));

var _ref55 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "58.25 54.32 77.66 43.11 97.08 54.32 77.66 65.53 58.25 54.32"
});

var _ref56 = /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 0 77.66 11.21 77.66 33.63 58.25 22.42 58.25 0"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-85"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 0 77.66 11.21 77.66 33.63 58.25 22.42 58.25 0"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "77.66 11.21 77.66 33.63 58.25 44.84 58.25 22.42 77.66 11.21"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-86"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-87",
  points: "77.66 11.21 77.66 33.63 58.25 44.84 58.25 22.42 77.66 11.21"
}))), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "58.25 22.42 58.25 44.84 38.83 33.63 38.83 11.21 58.25 22.42"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-88"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-89",
  points: "58.25 22.42 58.25 44.84 38.83 33.63 38.83 11.21 58.25 22.42"
})))));

var _ref57 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-90",
  points: "38.83 11.21 58.25 0 77.66 11.21 58.25 22.42 38.83 11.21"
});

function SvgCustomRequirement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 116.5 144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomRequirement);
export default __webpack_public_path__ + "static/media/custom-requirement.38819635.svg";
export { ForwardRef as ReactComponent };